// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_wB0","cls2":"ImpactHubModal-cls2_OPM ImpactHubModal-cls1_wB0"};